<template>
  <v-container
    class="emoney-users-container"
    fluid
  >
    <h1>Emoney Users</h1>
    <h2 v-if="!emoneyUsers || !emoneyUsersPagination.total">
      No Data
    </h2>
    <orders-table
      :emoney-users="emoneyUsers"
      :emoney-users-pagination="emoneyUsersPagination"
      :loading="loading"
    />
  </v-container>
</template>

<script>
import { mapState, mapActions } from 'vuex';
import { toQueryString } from '@/helpers';

import EmoneyUsersTable from '@/components/emoney';

export default {
  name: 'EmoneyUsers',
  components: {
    'orders-table': EmoneyUsersTable,
  },
  computed: {
    ...mapState({
      loading: state => state.emoneyUsersStore.loading,
      emoneyUsers: state => state.emoneyUsersStore.emoneyUsers,
      emoneyUsersPagination: state => state.emoneyUsersStore.emoneyUsersPagination,
    }),
  },
  async mounted() {
    this.getEmoneyUsers(toQueryString({ per_page: 5, page: 1, sortBy: 'created_at', sortDirection: 'DESC' }));
  },
  methods: {
    ...mapActions(['getEmoneyUsers']),
  },
};
</script>


<style lang="scss" scoped>
.emoney-users-container {
  max-width:1500px;
}

</style>



// WEBPACK FOOTER //
// src/views/emoney/EmoneyUsers.vue